import { NgModule } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { LUCIDE_ICONS } from './lucide-icons';

/**
 * Wrapper module so standalone components can import Lucide without
 * calling .pick() directly in their imports array (ModuleWithProviders
 * is not assignable to standalone imports).
 *
 * Usage in standalone components:
 *   imports: [LucideIconsModule]
 */
@NgModule({
  imports: [LucideAngularModule.pick(LUCIDE_ICONS)],
  exports: [LucideAngularModule],
})
export class LucideIconsModule {}
